import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarHalfFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M8.437 2.005c.414-.877 1.46-1.27 2.343-.815.346.178.619.467.783.815l1.785 3.78a.242.242 0 0 0 .177.143l3.993.606c.973.148 1.595 1.073 1.465 2.013-.053.38-.225.737-.496 1.013l-2.889 2.942a.31.31 0 0 0-.079.264l.721 4.157c.16.979-.525 1.884-1.452 2.05a1.7 1.7 0 0 1-1.12-.184l-3.57-1.962a.2.2 0 0 0-.196 0l-3.57 1.962c-.872.478-1.928.113-2.364-.753a1.822 1.822 0 0 1-.17-1.113l.682-4.155a.31.31 0 0 0-.078-.266L1.512 9.56a1.814 1.814 0 0 1-.03-2.495 1.722 1.722 0 0 1 1-.531l3.992-.606a.242.242 0 0 0 .178-.143l1.785-3.78Zm1.656.518c-.094-.048-.231-.023-.3.122l-.003.008C9 8.003 9 13.001 14.39 17.474a.2.2 0 0 0 .133.023.296.296 0 0 0 .183-.122.28.28 0 0 0 .054-.207l-.72-4.157a1.81 1.81 0 0 1 .488-1.56l2.889-2.942c.04-.041.07-.1.08-.168.026-.186-.1-.308-.204-.324L13.3 7.411a1.74 1.74 0 0 1-1.308-.985l-1.786-3.78a.26.26 0 0 0-.113-.123Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgStarHalfFilled);
export { ForwardRef as ReactComponent };
